import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInterceptor";
import { Eye, EyeOff } from "lucide-react";
import { useFormik } from "formik";
import { EmailConfigSchema } from "../../Validation/Validation";
const EmailConfiguration = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      host: "",
      port: "",
    },
    validationSchema: EmailConfigSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        await axiosInstance.put("emailsetting/updateEmailSetting", values);
        toast.success("Email configuration updated successfully!");
      } catch (error) {
        toast.error(
          error.response?.data?.message ||
            "Failed to update email configuration",
        );
      } finally {
        setLoading(false);
      }
    },
  });

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get("emailsetting/getEmailSetting");
      if (response.data?.data) {
        const { _id, createdAt, updatedAt, __v, ...cleanData } =
          response.data.data;
        formik.setValues(cleanData);
      }
    } catch (error) {
      toast.error("Failed to fetch email configuration");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="content-wrapper">
      <div className="page-header">
        <h3 className="page-title">Email Configuration</h3>
      </div>
      <div className="card">
        <div className="card-body">
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-4 mb-3">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  className={`form-control border border-dark`}
                  value={formik.values.email}
                  placeholder="Enter email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <div className="invalid-feedback">{formik.errors.email}</div>
              </div>
              <div className="col-3 mb-3">
                <label>App Password</label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className={`form-control border border-dark`}
                    value={formik.values.password}
                    placeholder="Enter app password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <span
                    className="input-group-text"
                    style={{
                      cursor: "pointer",
                      background: "#1a4a2e",
                      color: "#fff",
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <Eye className=" text-light" size={18} />
                    ) : (
                      <EyeOff className=" text-light" size={18} />
                    )}
                  </span>
                </div>
                <div className="invalid-feedback d-block">
                  {formik.errors.password}
                </div>
              </div>
              <div className="col-3 mb-3">
                <label>SMTP Host</label>
                <input
                  type="text"
                  name="host"
                  className={`form-control border border-dark`}
                  placeholder="Enter SMTP host"
                  value={formik.values.host}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}/>
                <div className="invalid-feedback">{formik.errors.host}</div>
              </div>
              <div className="col-2 mb-3">
                <label>Port</label>
                <input
                  type="number"
                  name="port"
                  className={`form-control border border-dark`}
                  placeholder="Enter port"
                  value={formik.values.port}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}/>
                <div className="invalid-feedback">{formik.errors.port}</div>
              </div>
            </div>
            <div className="text-center">
              <button
                className="btn btn-primary"
                type="submit"
                disabled={loading}>
                {loading ? "Processing..." : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EmailConfiguration;
